"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const atoms_1 = require("../../atoms");
const Login = ({ onSubmit, loading, emailPlaceholder, passwordPlaceholder, buttonTitle, bottomBox, }) => {
    const [user, setUser] = react_1.useState('');
    const [password, setPassword] = react_1.useState('');
    const handleSubmit = (e) => {
        e.preventDefault();
        if (user && password)
            onSubmit(user, password);
    };
    return (react_1.default.createElement("div", { className: "flex items-center justify-center px-4 py-12 min-h-screen dark:bg-black-800 bg-gray-50 sm:px-6 lg:px-8" },
        react_1.default.createElement("div", { className: "w-full max-w-md" },
            react_1.default.createElement("div", null,
                react_1.default.createElement(atoms_1.UniNowLogo, { className: "mx-auto w-auto h-20 dark:text-gray-400" })),
            react_1.default.createElement("form", { className: "mt-8", action: "#", onSubmit: handleSubmit },
                react_1.default.createElement("div", { className: "rounded-md shadow-sm" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(atoms_1.Input, { ariaLabel: emailPlaceholder, name: "email", type: "email", required: true, rounded: 'top', placeholder: emailPlaceholder, value: user, onChange: (e) => setUser(e.target.value) })),
                    react_1.default.createElement("div", { className: "-mt-px" },
                        react_1.default.createElement(atoms_1.Input, { ariaLabel: passwordPlaceholder, name: "password", type: "password", rounded: 'bottom', required: true, placeholder: passwordPlaceholder, value: password, onChange: (e) => setPassword(e.target.value) }))),
                react_1.default.createElement("div", { className: "mt-6" },
                    react_1.default.createElement(atoms_1.PrimaryButton, { disabled: loading, label: buttonTitle, ariaLabel: buttonTitle, type: atoms_1.ButtonType.submit, icon: atoms_1.LockIcon }))),
            react_1.default.createElement("div", { className: "flex flex-col justify-center m-auto pt-8 space-x-0 sm:flex-row sm:space-x-4" }, bottomBox))));
};
exports.default = Login;
